"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateMixPreviewRequestToJSON = exports.GenerateMixPreviewRequestFromJSONTyped = exports.GenerateMixPreviewRequestFromJSON = exports.instanceOfGenerateMixPreviewRequest = void 0;
var MixProperties_1 = require("./MixProperties");
/**
 * Check if a given object implements the GenerateMixPreviewRequest interface.
 */
function instanceOfGenerateMixPreviewRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "voiceoverPreviewId" in value;
    isInstance = isInstance && "voiceoverPreviewUrl" in value;
    isInstance = isInstance && "mixProperties" in value;
    return isInstance;
}
exports.instanceOfGenerateMixPreviewRequest = instanceOfGenerateMixPreviewRequest;
function GenerateMixPreviewRequestFromJSON(json) {
    return GenerateMixPreviewRequestFromJSONTyped(json, false);
}
exports.GenerateMixPreviewRequestFromJSON = GenerateMixPreviewRequestFromJSON;
function GenerateMixPreviewRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'voiceoverPreviewId': json['voiceover_preview_id'],
        'voiceoverPreviewUrl': json['voiceover_preview_url'],
        'mixProperties': (0, MixProperties_1.MixPropertiesFromJSON)(json['mix_properties']),
    };
}
exports.GenerateMixPreviewRequestFromJSONTyped = GenerateMixPreviewRequestFromJSONTyped;
function GenerateMixPreviewRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'voiceover_preview_id': value.voiceoverPreviewId,
        'voiceover_preview_url': value.voiceoverPreviewUrl,
        'mix_properties': (0, MixProperties_1.MixPropertiesToJSON)(value.mixProperties),
    };
}
exports.GenerateMixPreviewRequestToJSON = GenerateMixPreviewRequestToJSON;
